// extracted by mini-css-extract-plugin
export default {"soundTracks":"SoundTracks_soundTracks__NUns4","contentTitle":"SoundTracks_contentTitle__TDB5J","content":"SoundTracks_content__75AWu","backButton":"SoundTracks_backButton__na0G5"};